module.exports = __webpack_public_path__ + "static/media/baja-y-desguace-de-vehiculos.d35b2076.png";